export const environment = {

  production: true,
  http : {
    server                 : "https://distribuidoresbait.com/app/",
    coloniasPorCP          : 'servicio/direccion/colonias/:cp:',
    listaMunicipios        : 'servicio/direccion/municipios?nombre=:ciudad',
    listadoMediosPublicidad: 'servicio/funcion/listarMediosPublicidad',
    listadoRedesSociales   : 'servicio/funcion/listarRedesSociales',
    preregistro            : 'servicio/distribuidor/solicitud/registro',

    auth: {
      login       : 'api/thirdAuth',
      sso         : {
        serverWalmart          :'https://pfeddev.wal-mart.com/',
        api: {
          urlLoginSSO          :'api/generarUrl',
          generarSesionSSO     : "api/generarToken?codigo={code}",
          generarTokenEndpoint : "as/token.oauth2",
          instrospectionUser   : "as/introspect.oauth2",
          saveToken            : "api/guardarToken",
          userInfo             : "idp/userinfo.openid",
          revocationEndPoint   : "as/revoke_token.oauth2",
          closeSSO             : "idp/startSLO.ping"
        },
        tokenSSO               : "Basic Y3JtLWRpc3RyaWJ1aWRvcmVzLWRldjpiNWRhNzBkYy1kNTk0LTQwM2EtYjI2Ny0yOTYxOThhYzc1Yzk=",
        clientId               : "crm-distribuidores-dev",
        codeVerifier           : 'ZICGycnI97RVjvEu85NVGg655jPGp_De_EvonSHIMMosd8aGKxaeTMLJRCN14g-WlHoMk5PlYH4t75ke65XGoS07v03KrKDmwsv_QU-8TfBZhuChooe--ZGzzWti9Rsc'
      },
      cerrarSesion: "api/cerrarSesion",
      menu        : 'api/usuario/permisos',
      recuperacion: {
        solicitud        : 'servicio/recuperacion/solicitud',
        cambiovUser: 'servicio/recuperacion/cambio/:token:',
        activarCuenta: 'servicio/funcion/activarCuenta/:token:'
      },
    },
  },
  regex: {
    cp            : /^[0-9]{5}$/,
    rfc           : /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
    telefono      : /^\d{10}?$/,
    correo        : /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    vUser      : /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-.)]).{8,20}$/,
    url           : /^https?                                                                                                                                                                                           : \/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/,
    iccid         : /^\d{19}$/,
    pin           : /^\d{4}$/,
    curp          : /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
    imei          : /^[0-9]{15,17}$/,
    inputTypeNumer: /^([0-9])*$/,
    offeringId    : /^[1-9][0-9]{9}$/,
    base64        : /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/
  },
  localStorage: {
    user: 'ord.distribuidores.user',
    menu: 'ord.distribuidores.menu',
  },
  apiKeys: {
    ordServicio: '52cb7a88f0894bc79f7e7549676c6c5a'
  },
  tamanioPaginador : [ 10, 50, 100, 200, 300, 500, 1000 ]
};
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
